import {
  SALESTARGET_LOADING,
  GET_SALESTARGET,
  GET_SALESTARGET_SUCCESS,
  GET_SALESTARGET_FAIL,
  ADD_SALESTARGET_SUCCESS,
  ADD_SALESTARGET_FAIL,
  DELETE_SALESTARGET_SUCCESS,
  DELETE_SALESTARGET_FAIL,
  UPDATE_SALESTARGET_SUCCESS,
  UPDATE_SALESTARGET_FAIL,
  SALESTARGET_RESET
} from "./actionType";

const INIT_STATE = {
  salesTargets: [],
  error: {},
};

const SalesTarget = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SALESTARGET_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SALESTARGET:
          return {
            ...state,
            salesTargets: action.payload.data,
            isSalesTargetCreated: false,
            isSalesTargetSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SALESTARGET_FAIL:
      switch (action.payload.actionType) {
        case GET_SALESTARGET_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSalesTargetCreated: false,
            isSalesTargetSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SALESTARGET: {
      return {
        ...state,
        isSalesTargetCreated: false,
        loading: true,
      };
    }

    case SALESTARGET_LOADING: {
      return {
        ...state,
        isSalesTargetCreated: false,
        loading: true,
      };
    }

    case ADD_SALESTARGET_SUCCESS:
      return {
        ...state,
        isSalesTargetCreated: true,
        loading: false,
        salesTargets: [action.payload.data, ...state.salesTargets],
      };

    case ADD_SALESTARGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SALESTARGET_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesTargetCreated: true,
        salesTargets: state.salesTargets.filter(
          salesTarget => salesTarget.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SALESTARGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SALESTARGET_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesTargetCreated: true,
        salesTargets: state.salesTargets.map(salesTarget =>
          salesTarget.id.toString() === action.payload.data.id.toString() ? { ...salesTarget, ...action.payload.data } : salesTarget
        ),
      };

    case UPDATE_SALESTARGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SALESTARGET_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default SalesTarget;